import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from '../api.service'; 
import { Router } from '@angular/router';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements HttpInterceptor {
  constructor(
    private cookie: CookieService, 
    private apiService: ApiService,
    private router: Router,
    private dialogService: DialogService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.cookie.get('access_token');

    if (req.url.endsWith('/auth/refresh')) {
      return next.handle(req);
    }

    let clonedReq = req;
    if (accessToken) {
      clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // 401: Unauthorized
        if (error.status === 401) {
          
          // BUG FIX: Prevent redirecting to login if they are currently trying to verify an OTP
          if (req.url.includes('/auth/verify-otp')) {
            this.showGlobalError(error.error?.detail || 'Incorrect code. Please try again.');
            return throwError(() => error);
          }

          const refreshToken = this.cookie.get('refresh_token');
          
          if (refreshToken) {
            return this.apiService.refreshAccessToken(refreshToken).pipe(
              switchMap((newToken: string) => {
                this.cookie.set('access_token', newToken, { path: '/' }); 

                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`
                  }
                });
                return next.handle(retryReq);
              }),
              catchError((refreshError) => {
                this.handleAuthFailure();
                return throwError(() => refreshError);
              })
            );
          } else {
            this.handleAuthFailure();
          }
        } 
        // 403: Forbidden/Access Expired
        else if (error.status === 403) {
          this.showGlobalError(error.error?.detail || 'Your training access window has expired.');
          this.handleAuthFailure();
        } 
        // GLOBAL ERROR CATCH-ALL
        else {
          const errorMessage = error.error?.detail || error.error?.message || 'We could not process your request just now. Please try again.';
          this.showGlobalError(errorMessage);
        }

        return throwError(() => error);
      })
    );
  }

  private showGlobalError(message: string): void {
    this.dialogService.open(ErrorDialogComponent, {
      data: { message: message },
      showHeader: false, // Hides the default PrimeNG header so we can use custom styling
      width: '90%',
      style: { 'max-width': '400px', 'border-radius': '0.5rem' },
      baseZIndex: 10000,
      dismissableMask: true
    });
  }

  private handleAuthFailure(): void {
    this.cookie.delete('access_token', '/');
    this.cookie.delete('refresh_token', '/');
    this.router.navigate(['/login']);
  }
}